/* global  */ // tUrl等のグローバル変数を宣言する
import scrollLock from './functions/_scrollLock.js' // スクロールロック
// import autoScroll from './functions/_autoScroll.js' // 自動スクロール
// import isDevice from './functions/_isDevice.js' // UserAgentをpc,sp,tabの形で返す
import isBrowser from './functions/_isBrowser.js' // UserAgentをブラウザ名で返す

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

// ######## ########  ##     ## ##    ## ##    ##  #######
//    ##    ##     ## ##     ## ###   ## ##   ##  ##     ##
//    ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
//    ##    ########  ##     ## ## ## ## #####     #######
//    ##    ##   ##   ##     ## ##  #### ##  ##   ##     ##
//    ##    ##    ##  ##     ## ##   ### ##   ##  ##     ##
//    ##    ##     ##  #######  ##    ## ##    ##  #######
function trunk8() {
  $('.js-t8.line3').trunk8({
    // 指定要素に行数制限をかける
    lines: 3,
    fill: '...',
  })
  $('.js-t8.line2').trunk8({
    // 指定要素に行数制限をかける
    lines: 2,
    fill: '...',
  })
  $('.js-t8.line1').trunk8({
    // 指定要素に行数制限をかける
    lines: 1,
    fill: '...',
  })
}
if ($('.js-t8')[0]) {
  // 要素を検出したら実行
  trunk8()
  $(window).on('load resize ', function () {
    trunk8()
  })
}
$('.Qtext').on('click', function () {
  $(this).siblings('.Atext').slideToggle()
  $(this).toggleClass('active')
})
/*
 ######   #######   #######  ##    ## #### ########
##    ## ##     ## ##     ## ##   ##   ##  ##
##       ##     ## ##     ## ##  ##    ##  ##
##       ##     ## ##     ## #####     ##  ######
##       ##     ## ##     ## ##  ##    ##  ##
##    ## ##     ## ##     ## ##   ##   ##  ##
 ######   #######   #######  ##    ## #### ########
*/
/**
 * @param key {string}
 * @param val {string}
 * @param maxAge {number} 寿命秒数
 * @param secure {bool}
 */
function setCookie(key, val, maxAge = 60 * 60 * 24 * 365, secure = true, path = '/', sameSite = 'lax', other = '') {
  let setData = key + '=' + val + ';max-age=' + maxAge + ';path=' + path + ';samesite=' + sameSite + other
  if (secure) {
    setData += ';secure'
  }
  document.cookie = setData
}

function getCookie(key) {
  return ((document.cookie + ';').match(key + '=([^¥S;]*)') || [])[1]
}

jQuery(function ($) {
  $('.Tab-Ank-Link').click(function () {
    $('#topAnk').animate({ scrollTop: 0 }, 'fast')
    $('#topAnk2').animate({ scrollTop: 0 }, 'fast')
  })

  // ##     ## ########    ###    ########  ######## ########
  // ##     ## ##         ## ##   ##     ## ##       ##     ##
  // ##     ## ##        ##   ##  ##     ## ##       ##     ##
  // ######### ######   ##     ## ##     ## ######   ########
  // ##     ## ##       ######### ##     ## ##       ##   ##
  // ##     ## ##       ##     ## ##     ## ##       ##    ##
  // ##     ## ######## ##     ## ########  ######## ##     ##
  function headercolor() {
    if (window.matchMedia('(min-width: 600px)').matches) {
      $('.header__frame').each(function () {
        var scroll = $(window).scrollTop() //スクロールした量を計測して変数に代入
        if (scroll > 350) {
          //395以上スクロールしたら処理実行
          $('.headerPulldown').addClass('active') //超過したときに該当のクラスにstopを追加
          $('.header__logo').addClass('active') //超過したときに該当のクラスにstopを追加
          $('.header').addClass('bgw')
        } else {
          //395以下の時スクロールしたら処理実行
          $('.headerPulldown').removeClass('active') //超過したときに該当のクラスにstopを追加
          $('.header__logo').removeClass('active') //超過したときに該当のクラスにstopを追加
          $('.header').removeClass('bgw')
        }
      })
    } else {
      //600px以下の場合
    }
  }
  $(window).scroll(function () {
    //スクロール時に一度だけ行う処理
    //600px以上の場合
    headercolor()
  })
  $(document).ready(function () {
    headercolor()
  })
  // ########    ###    ########  ########         #### ##    ##
  // ##         ## ##   ##     ## ##                ##  ###   ##
  // ##        ##   ##  ##     ## ##                ##  ####  ##
  // ######   ##     ## ##     ## ######   #######  ##  ## ## ##
  // ##       ######### ##     ## ##                ##  ##  ####
  // ##       ##     ## ##     ## ##                ##  ##   ###
  // ##       ##     ## ########  ########         #### ##    ##
  function fadeinanime() {
    if (window.matchMedia('(min-width:768px)').matches) {
      //768px以上の場合
      $('.fade-in').each(function () {
        let scroll = $(window).scrollTop()
        let position = $(this).offset().top
        let windowHeight = $(window).height()
        if (scroll > position - windowHeight) {
          $(this).addClass('active')
        }
      })
      $('.slide-in').each(function () {
        let scroll = $(window).scrollTop() //TOPからのスクロール量を計測
        let position = $(this).offset().top //TOPからの位置を計測
        let windowHeight = $(window).height() //ページ全体の高さ計測
        if (scroll > position - windowHeight) {
          $(this).addClass('active')
        }
      })
    } else {
      //768px以下の場合
      $('.fade-in').each(function () {
        let scroll = $(window).scrollTop() //TOPからのスクロール量を計測
        let position = $(this).offset().top //TOPからの位置を計測
        let windowHeight = $(window).height() //ページ全体の高さ計測
        if (scroll > position - windowHeight) {
          $(this).addClass('active')
        }
      })
      $('.slide-in').each(function () {
        let scroll = $(window).scrollTop() //TOPからのスクロール量を計測
        let position = $(this).offset().top //TOPからの位置を計測
        let windowHeight = $(window).height() //ページ全体の高さ計測
        if (scroll - 20 > position - windowHeight) {
          $(this).addClass('active')
        }
      })
    }
  }
  $(window).scroll(function () {
    //スクロール時の処理
    fadeinanime()
  })
  $(document).ready(function () {
    fadeinanime()
    $('.archiveVer').addClass('active')
  })
  $('.Blue-Tab').on('click', function () {
    $(this).parents('.tab-wrap').removeClass('tab02')
    $(this).parents('.tab-wrap').addClass('tab01')
  })
  $('.Green-Tab').on('click', function () {
    $(this).parents('.tab-wrap').removeClass('tab01')
    $(this).parents('.tab-wrap').addClass('tab02')
  })
  // ######  ##      ## #### ########  ######## ########
  // ##    ## ##  ##  ##  ##  ##     ## ##       ##     ##
  // ##       ##  ##  ##  ##  ##     ## ##       ##     ##
  //  ######  ##  ##  ##  ##  ########  ######   ########
  //       ## ##  ##  ##  ##  ##        ##       ##   ##
  // ##    ## ##  ##  ##  ##  ##        ##       ##    ##
  //  ######   ###  ###  #### ##        ######## ##     ##
  if ($('.rec-swiper__container')[0]) {
    // リクルート
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const RecSwiper = new Swiper('.rec-swiper__container', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 1500, // アニメ速度
      loop: true, // ループ
      spaceBetween: 15,
      loopAdditionalSlides: 3, //ループ演出用のクローン数を増やして安定化させる
      centeredSlides: true,
      slidesPerView: 1, //表示数変更
      autoplay: {
        delay: 250000, // 待機時間
        disableOnInteraction: false, // 操作されたらオート解除
      },
    })
  }
  /*
  ##     ## ##     ##
  ###   ### ##     ##
  #### #### ##     ##
  ## ### ## ##     ##
  ##     ##  ##   ##
  ##     ##   ## ##
  ##     ##    ###
  */
  /*
        ##     ##  #######  ##     ## #### ########
        ###   ### ##     ## ##     ##  ##  ##
        #### #### ##     ## ##     ##  ##  ##
####### ## ### ## ##     ## ##     ##  ##  ######
        ##     ## ##     ##  ##   ##   ##  ##
        ##     ## ##     ##   ## ##    ##  ##
        ##     ##  #######     ###    #### ########
*/

  const pcMovie = document.getElementById('pcMovie')
  const spMovie = document.getElementById('spMovie')
  const moviePlaybtn = document.getElementById('mvPlaybtn')

  const movieText = document.getElementsByClassName('js-movieText')

  if (pcMovie || spMovie) {
    pcMovie.volume = 0
    spMovie.volume = 0
    movieStart()
    topInit()
    window.addEventListener('resize', function (e) {
      movieStart()
    })

    spMovie.addEventListener('timeupdate', function () {
      // console.log(spMovie.currentTime)
      const time = spMovie.currentTime
      const sec1 = 5.5
      const sec2 = 10.5
      const sec3 = 15.7
      const sec4 = 20.5
      const secSep = 0.5
      if (time <= sec1 - secSep) {
        movieTextSync(1)
        return
      }
      if (time <= sec1) {
        movieTextSync(0)
        return
      }
      if (time <= sec2 - secSep) {
        movieTextSync(2)
        return
      }
      if (time <= sec2) {
        movieTextSync(0)
        return
      }
      if (time <= sec3 - secSep) {
        movieTextSync(3)
        return
      }
      if (time <= sec3) {
        movieTextSync(0)
        return
      }
      if (time <= sec4 - secSep) {
        movieTextSync(4)
        return
      }
      if (time <= sec4) {
        movieTextSync(0)
      }
    })

    moviePlaybtn.addEventListener('click', function () {
      console.log('playbtn clicked')
      movieStart()
    })
  }

  // 動画の文字　指定した番号以外を消す
  function movieTextSync(num) {
    for (let index = 0; index < movieText.length; index++) {
      const item = movieText[index]
      if (item.classList.contains('js-movieText--' + num)) {
        if (!item.classList.contains('active')) {
          item.classList.add('active')
        }
      } else {
        if (item.classList.contains('active')) {
          item.classList.remove('active')
        }
      }
    }
  }

  // デバイスに応じた動画を再生する
  function movieStart() {
    if (window.matchMedia('(min-width:769px)').matches) {
      pcMovie.play()
      spMovie.pause()
      if (pcMovie.paused) {
        pcMovie.style.opacity = '0'
        moviePlaybtn.style.display = 'block'
      } else {
        pcMovie.style.opacity = '1'
        moviePlaybtn.style.display = 'none'
      }
    } else if (window.matchMedia('(max-width:768px)').matches) {
      pcMovie.pause()
      spMovie.play()
      if (spMovie.paused) {
        spMovie.style.opacity = '0'
        moviePlaybtn.style.display = 'block'
        movieTextSync(1)
      } else {
        spMovie.style.opacity = '1'
        moviePlaybtn.style.display = 'none'
      }
    }
  }

  function movieReset() {
    // console.log('reset')
    pcMovie.currentTime = 0 // 動画再生位置を初期化
    spMovie.currentTime = 0 // 動画再生位置を初期化
  }

  function topInit() {
    if (document.getElementById('topInit')) {
      if (getCookie('topInit') !== '1') {
        // スプラッシュスクリーンを実行

        document.getElementById('site-contents').scrollIntoView(true)
        scrollLock('body', '#topMain', 'js-topWait')

        $('.js-topWait').removeClass('js-topWait')

        $(document).on('animationend webkitAnimationEnd', '#topInit--2', function () {
          // SSのテキストをMVに重ねる
          const posItem = document.getElementById('js-posTrace')

          if (window.matchMedia('(min-width:769px)').matches) {
            //PC
            posItem.style.margin = '-4vw 0 0 -20vw'
          } else if (window.matchMedia('(max-width:768px)').matches) {
            //SP
            // SSのテキストをMVに重ねる
            const posItem = document.getElementById('js-posTrace')
            const target = document.getElementById('js-posTrace--' + posItem.dataset.traceTarget)
            const targetX = target.getBoundingClientRect().left
            const targetY = target.getBoundingClientRect().top + window.pageYOffset
            const itemX = posItem.getBoundingClientRect().left
            const itemY = posItem.getBoundingClientRect().top + window.pageYOffset
            const x = targetX - itemX
            const y = targetY - itemY
            posItem.style.transform = 'translate(' + x + 'px,' + y + 'px)'
          }
        })

        scrollLock('body', '#topMain', 'js-topWait')

        const lastAnime = document.getElementById('js-posTrace')
        lastAnime.addEventListener('transitionend', function (e) {
          movieReset()
        })
        lastAnime.addEventListener('webkitTransitionend', function (e) {
          movieReset()
        })

        setCookie('topInit', 1, 60 * 60)
        // setCookie('topInit', 1, 1)
      } else {
        // Cookieがある場合はすぐにセットアップ
        document.getElementById('topInit').parentNode.removeChild(document.getElementById('topInit'))
        $('.js-topWait').removeClass('js-topWait')
        scrollLock('body', '#topMain', 'js-topWait')
      }
    }
    if (document.getElementById('initSkip')) {
    }
  }

  /*
   ######  ######## ########  ##     ##         ########   #######  ########
  ##    ## ##       ##     ## ##     ##         ##     ## ##     ## ##     ##
  ##       ##       ##     ## ##     ##         ##     ## ##     ## ##     ##
   ######  ######   ########  ##     ## ####### ########  ##     ## ########
        ## ##       ##   ##    ##   ##          ##        ##     ## ##
  ##    ## ##       ##    ##    ## ##           ##        ##     ## ##
   ######  ######## ##     ##    ###            ##         #######  ##
  */
  if (document.getElementsByClassName('js-mousePop')[0]) {
    const mousePopItems = document.getElementsByClassName('js-mousePop')
    let mouseX = 0
    let mouseY = 0
    for (let index = 0; index < mousePopItems.length; index++) {
      const element = mousePopItems[index]
      element.onmousemove = function (e) {
        mouseX = e.clientX
        mouseY = e.clientY
        element.getElementsByClassName('js-mousePop-item')[0].style.top = mouseY + 'px'
        element.getElementsByClassName('js-mousePop-item')[0].style.left = mouseX + 'px'
      }
    }
  }

  /*
  ##     ##    ###    ########
  ###   ###   ## ##   ##     ##
  #### ####  ##   ##  ##     ##
  ## ### ## ##     ## ########
  ##     ## ######### ##
  ##     ## ##     ## ##
  ##     ## ##     ## ##
  */
  // PCはモーダル　SPはアコーディオンで展開する
  $(document).on('click ', '.js-map--open', function () {
    const target = this.dataset.map
    if (window.matchMedia('(min-width:769px)').matches) {
      $('.js-map').removeClass('active') // 他のモーダルを消す
      $('.js-map--' + target).addClass('active')
      $('#modalOverlay').addClass('active')
      scrollLock('body', '#modalOverlay')
    } else {
      $('.js-map--' + target).toggleClass('active')
      $('#modalOverlay').removeClass('active')
    }
  })
  // モーダル撤去
  function mapClose() {
    $('.js-map').removeClass('active')
    $('#modalOverlay').removeClass('active')
    scrollLock('body', '#modalOverlay')
  }
  $(document).on('click', '.js-map-close', function () {
    mapClose()
  })
  if (document.getElementsByClassName('js-map')[0]) {
    $(window).on('resize', function () {
      if (window.matchMedia('(min-width:769px)').matches) {
        mapClose()
      }
    })
  }
})

/*
  ########  #######  ########          ########  #### ########
     ##    ##     ## ##     ##         ##     ##  ##       ##
     ##    ##     ## ##     ##         ##     ##  ##      ##
     ##    ##     ## ########  ####### ########   ##     ##
     ##    ##     ## ##                ##     ##  ##    ##
     ##    ##     ## ##                ##     ##  ##   ##
     ##     #######  ##                ########  #### ########
  */
/*
           ######   ######  ########   #######  ##       ##
          ##    ## ##    ## ##     ## ##     ## ##       ##
          ##       ##       ##     ## ##     ## ##       ##
  #######  ######  ##       ########  ##     ## ##       ##
                ## ##       ##   ##   ##     ## ##       ##
          ##    ## ##    ## ##    ##  ##     ## ##       ##
           ######   ######  ##     ##  #######  ######## ########
  */

// stickyの代替処理
if (document.getElementById('js-fixArea')) {
  fixArea()
}
function fixArea() {
  let isAction = false // 処理フラグ
  let scrollY = window.pageYOffset // 縦方向のスクロール量
  const frame = document.getElementById('js-fixArea') // フレーム
  const item = document.getElementById('js-fixArea-item') // スクロールさせるアイテム
  const adjust = document.getElementById('header').offsetHeight * 1.5 // ヘッダー要素の調整
  let state = 'stay'
  document.addEventListener(
    'scroll',
    function () {
      scrollY = window.pageYOffset // スクロール量更新
      fixAreaApply()
    },
    { passive: true }
  )
  fixAreaApply()
  function fixAreaApply() {
    if (!isAction) {
      // レンダリング準備が整ったら開始
      requestAnimationFrame(function () {
        isAction = false
        const frameHeight = frame.offsetHeight
        const frameTop = frame.getBoundingClientRect().top + scrollY
        const frameBottom = frameTop + frameHeight
        const itemHeight = item.offsetHeight
        const itemTop = item.getBoundingClientRect().top + scrollY
        const itemBottom = itemTop + itemHeight
        // フレームがアイテムより高くなければ終了
        if (frameHeight <= itemHeight) {
          isAction = false // フラグをOFFに戻す
          return
        }

        if (state === 'stay') {
          // スクロールがアイテムのTOPを追い越したら追従
          if (scrollY + adjust >= itemTop) {
            item.classList.add('move')
            state = 'move'
          }
        } else if (state === 'move') {
          if (itemTop <= frameTop) {
            item.classList.remove('move')
            state = 'stay'
          } else if (itemBottom >= frameBottom) {
            item.classList.remove('move')
            item.classList.add('end')
            state = 'end'
          }
        } else {
          if (item.getBoundingClientRect().top > adjust) {
            item.classList.remove('end')
            item.classList.add('move')
            state = 'move'
          }
        }
      })
      isAction = true
    }
  }
}

/*
             ###     ######  ######## #### ##     ## ########
            ## ##   ##    ##    ##     ##  ##     ## ##
           ##   ##  ##          ##     ##  ##     ## ##
  ####### ##     ## ##          ##     ##  ##     ## ######
          ######### ##          ##     ##   ##   ##  ##
          ##     ## ##    ##    ##     ##    ## ##   ##
          ##     ##  ######     ##    ####    ###    ########
  */
// 走査線に入っているアイテムをアクティブにする
if (document.getElementsByClassName('js-scrollNav')[0]) {
  scrollNav()
}
function scrollNav() {
  // スクロールナビゲーション
  let isAction = false // 処理フラグ
  let scrollY = window.pageYOffset // 縦方向のスクロール量
  const items = document.getElementsByClassName('js-scrollNav') // 処理対象
  const triggers = document.getElementsByClassName('js-scrollNav-trigger') // 判定対象
  const sensor = document.getElementById('js-scrollNav-sensor') // 走査線要素 ID指定
  document.addEventListener(
    'scroll',
    function (ev) {
      // スクロール量の更新だけを行う
      scrollY = window.pageYOffset // スクロール量更新
      scrollNavApply()
    },
    { passive: true }
  )
  scrollNavApply()
  function scrollNavApply() {
    if (window.matchMedia('(max-width:768px)').matches) {
      // SPはスキップ
      return
    }
    if (!isAction) {
      // レンダリング準備が整ったら開始
      requestAnimationFrame(function () {
        isAction = false
        for (let index = 0; index < triggers.length; index++) {
          const trigger = triggers[index]
          const triggerStart = trigger.getBoundingClientRect().top + scrollY // 画面上部からのターゲットの位置
          const triggerEnd = triggerStart + trigger.offsetHeight // 画面下部からのターゲットの位置
          const sensorVal = sensor.getBoundingClientRect().top + window.pageYOffset
          // ターゲットの上端～下端に走査線が入ったら処理
          if (sensorVal > triggerStart && sensorVal < triggerEnd) {
            const target = trigger.dataset.navTarget // 制御対象名を取得
            // 全てのactiveを外す
            for (let index = 0; index < items.length; index++) {
              const item = items[index]
              item.classList.remove('active')
            }
            // 対象アイテムをアクティブにする
            const targetItems = document.getElementsByClassName('js-scrollNav--' + target)
            for (let index = 0; index < targetItems.length; index++) {
              const targetItem = targetItems[index]
              targetItem.classList.add('active')
              targetItem.classList.add('pass') // アクティブとは別で通過済みのフラグをつける
            }
            break // 以降の判定は飛ばす
          }
        }
      })
      isAction = true
    }
  }
}

/*
  ########     ###    ########     ###
  ##     ##  ##   ##  ##     ##  ##   ##
  ########  ##     ## ########  ##     ##
  ##        ######### ##   ##   #########
  ##        ##     ## ##     ## ##     ##
  */
// パララックス
if (isBrowser !== 'ie' && document.getElementsByClassName('js-para')[0]) {
  parallax()
}
function parallax() {
  let isAction = false // 処理フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const paraItems = document.getElementsByClassName('js-para')
  document.addEventListener(
    'scroll',
    function () {
      scrollY = window.pageYOffset // スクロール量更新
      parallaxApply()
    },
    { passive: true }
  )
  parallaxApply()
  function parallaxApply() {
    if (!isAction) {
      // レンダリング準備が整ったら開始
      requestAnimationFrame(function () {
        isAction = false
        for (let index = 0; index < paraItems.length; index++) {
          const paraItem = paraItems[index]
          let paraVal
          if (window.matchMedia('(min-width:769px)').matches) {
            //PC
            paraVal = paraItem.dataset.paraPc
          } else {
            //SP
            paraVal = paraItem.dataset.paraSp
          }

          paraItem.style.transform = 'translate3d(0,' + scrollY * paraVal + 'px,0)'
        }
      })
      isAction = true
    }
  }
}

/*
  ##       ######  #######  #####  ######
  ##      ##    ##    ###  ##   ## ##   ##
  ##      ##    ##   ###   ####### ##   ##
  ##      ##    ##  ###    ##   ## ##   ##
  #######  ######  ####### ##   ## ######
  */
/* global lozad */
lozad('.lozad', {
  rootMargin: '5%',
  loaded: function (el) {
    el.classList.add('active') // 画面に交差した要素をactive
  },
}).observe()

/*
 ######     ###    ########    ###    ########  ####
##    ##   ## ##   ##         ## ##   ##     ##  ##
##        ##   ##  ##        ##   ##  ##     ##  ##
 ######  ##     ## ######   ##     ## ########   ##
      ## ######### ##       ######### ##   ##    ##
##    ## ##     ## ##       ##     ## ##    ##   ##
 ######  ##     ## ##       ##     ## ##     ## ####
*/
// SP TOPの固定背景がバウンススクロールで見える問題の対応
if (isBrowser === 'safari') {
  if (document.getElementById('top-bg')) {
    scrollValToggle('#top-bg', window.innerHeight * 2.5, 'hide')
  }
}

/**
 * @function scrollValToggle
 * @param {string} targetSelector ターゲットとする一意なセレクタ
 * @param {int} scrollVal 基準となるスクロール量
 * @param {string} toggleClass 切り替えるクラス名
 */
function scrollValToggle(targetSelector, scrollVal = 500, toggleClass = 'active') {
  let isWait = false // 待機フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const target = document.querySelector(targetSelector) // ターゲット要素
  let scToggleSwitch = false // ターゲット要素のONOFF状態
  document.addEventListener('scroll', function (ev) {
    scrollValToggleApply()
  })
  scrollValToggleApply()
  function scrollValToggleApply() {
    if (isWait) {
      return
    }
    isWait = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.pageYOffset // スクロール量
      if (scrollY >= scrollVal && !scToggleSwitch) {
        //トップから指定px以上スクロールしたらON
        target.classList.add(toggleClass)
        scToggleSwitch = true
      } else if (scrollY < scrollVal && scToggleSwitch) {
        //スクロールが足りない時はOFF
        target.classList.remove(toggleClass)
        scToggleSwitch = false
      }
      isWait = false
    })
  }
}

/*
 ######   #######  ##    ## ########
##    ## ##     ## ###   ## ##
##       ##     ## ####  ## ##
##       ##     ## ## ## ## ######
##       ##     ## ##  #### ##
##    ## ##     ## ##   ### ##
 ######   #######  ##    ## ##
*/
// 個人のお客様の確認画面で法人関連の項目を消す
if (document.querySelector('.mw_wp_form_confirm')) {
  if (document.querySelector('[name="user-type"]').value === '個人のお客さま') {
    const corpItems = document.getElementsByClassName('js-formToggle--corp')
    for (let index = 0; index < corpItems.length; index++) {
      corpItems[index].style.display = 'none'
    }
  }
}

/*
########  #######  ########           ######   ######  ########   #######  ##       ##
   ##    ##     ## ##     ##         ##    ## ##    ## ##     ## ##     ## ##       ##
   ##    ##     ## ##     ##         ##       ##       ##     ## ##     ## ##       ##
   ##    ##     ## ########  #######  ######  ##       ########  ##     ## ##       ##
   ##    ##     ## ##                      ## ##       ##   ##   ##     ## ##       ##
   ##    ##     ## ##                ##    ## ##    ## ##    ##  ##     ## ##       ##
   ##     #######  ##                 ######   ######  ##     ##  #######  ######## ########
*/
if (document.getElementById('topScroll')) {
  scrollValToggle('#topScroll', 1, 'spHide')
}
